"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _Color = require("../core/Color");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-image: ", ";\n  background-size: ", ";\n  height: ", ";\n  width: ", ";\n  opacity: ", ";\n  pointer-events: none;\n  position: absolute;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  right: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isVertical = function isVertical(side) {
  return side === 'top' || side === 'bottom';
};

var UIOverhang = _styledComponents.default.div.withConfig({
  displayName: "UIOverhang",
  componentId: "sc-1p1lbb5-0"
})(_templateObject(), function (_ref) {
  var gradientColor = _ref.gradientColor,
      side = _ref.side;
  return "linear-gradient(to " + side + ", " + (0, _Color.rgba)(gradientColor, 0) + ", " + gradientColor + ")";
}, function (_ref2) {
  var side = _ref2.side,
      size = _ref2.size;
  return isVertical(side) ? "100% " + size + "px}" : size + "px 100%";
}, function (_ref3) {
  var side = _ref3.side,
      size = _ref3.size;
  return isVertical(side) && size + "px";
}, function (_ref4) {
  var side = _ref4.side,
      size = _ref4.size;
  return !isVertical(side) && size + "px";
}, function (_ref5) {
  var opacity = _ref5.opacity;
  return opacity;
}, function (_ref6) {
  var side = _ref6.side;
  return side !== 'bottom' && 0;
}, function (_ref7) {
  var side = _ref7.side;
  return side !== 'top' && 0;
}, function (_ref8) {
  var side = _ref8.side;
  return side !== 'right' && 0;
}, function (_ref9) {
  var side = _ref9.side;
  return side !== 'left' && 0;
});

UIOverhang.propTypes = {
  gradientColor: _propTypes.default.string.isRequired,
  opacity: _propTypes.default.number.isRequired,
  side: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']).isRequired,
  size: _propTypes.default.number.isRequired
};
UIOverhang.defaultProps = {
  gradientColor: _colors.KOALA,
  opacity: 1,
  size: 14
};
var _default = UIOverhang;
exports.default = _default;
module.exports = exports.default;